import $ from 'jquery';

window.$ = window.jQuery = $;

import './bootstrap';

import Swiper from 'swiper';

import SlimSelect from "slim-select";
import "jquery-ui/dist/jquery-ui";

import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import {MotionPathPlugin} from "gsap/MotionPathPlugin";

import {Autoplay, Navigation, Pagination} from "swiper/modules";

import Quill from 'quill';


window.$.datepicker = require('jquery-ui/ui/widgets/datepicker');
window.axios = require('axios');

Swiper.use([Pagination, Navigation, Autoplay]);
window.Swiper = Swiper;

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(MotionPathPlugin);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.MotionPathPlugin = MotionPathPlugin;

// Vue 개발 도구 활성화
// window.Vue.config.devtools = true;

window.SlimSelect = SlimSelect;

import Swal from 'sweetalert2';

window.Swal = Swal;

import {createApp} from 'vue';
import App from './App.vue';

window.Vue = {createApp};
const app = createApp(App);

// Vue 개발 도구 활성화
app.config.devtools = true;

/**
 * Swal.fire 기본형태
 * @param type
 * @param message
 * @param link
 * @param callback
 * */
function swalAlert({type = 'info', message = '알림입니다.', title = '알림', icon = null, callback = null, html = null} = {}) {

    if (icon === null) {
        icon = type;
    }

    if (type === 'question') {
        Swal.fire({
            icon : icon,
            title: title,
            ...(html ? {html: html} : {text: message}),
            showCancelButton : true,
            confirmButtonText: '확인',
            cancelButtonText : '닫기',
            reverseButtons   : true,
        }).then((result) => {
            if (result.isConfirmed && typeof callback === 'function') {
                callback();
            }
        });
    } else {
        Swal.fire({
            icon : icon,
            title: title,
            ...(html ? {html: html} : {text: message}),
            confirmButtonText: '확인',
            reverseButtons   : true,
        }).then((result) => {
            if (result.isConfirmed && typeof callback === 'function') {
                callback();
            }
        });
    }
}

window.swalAlert = swalAlert;


app.component('form-error', {
    props   : {
        message: String,
    },
    template: '<label v-if="!!message" class="error form-text is-invalid invalid-feedback d-block">@{{ message }}</label>'
});

app.component('form-text', {
    props   : {
        field: String,
        value: String,
        error: Boolean,
    },
    template: '<input type="text" @input="change" :name="field" class="form-control" :value="value" v-bind:class="{\'is-invalid\' : error}" :key="field" autocomplete="one-time-code">',
    methods : {
        change($event) {
            $event.target.value = $event.target.value.replace(/[^a-zA-Z0-9]/g, ''); // 특수문자 제거
            this.$emit('input', $event.target.value);
        }
    }
});

app.component('form-radio', {
    props   : {
        title     : String,
        field     : String,
        value     : String,
        inputValue: String,
        checked   : String,
        error     : Boolean,
    },
    template: '<input type="radio" :name="field" :value="inputValue" @change="change">',
    methods : {
        change() {
            this.$emit('input', this.inputValue);
        }
    },
    data() {
        return {
            id: this.field + parseInt(Math.random() * 1000000)
        }
    }
});

$.datepicker.setDefaults({
    closeText         : '닫기',
    prevText          : '이전달',
    nextText          : '다음달',
    currentText       : '오늘',
    monthNames        : ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
    monthNamesShort   : ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
    dayNames          : ['일', '월', '화', '수', '목', '금', '토'],
    dayNamesShort     : ['일', '월', '화', '수', '목', '금', '토'],
    dayNamesMin       : ['일', '월', '화', '수', '목', '금', '토'],
    weekHeader        : 'Wk',
    dateFormat        : 'yy-mm-dd',
    firstDay          : 0,
    isRTL             : false,
    showMonthAfterYear: true,
    yearSuffix        : '년',
    changeMonth       : false,
    changeYear        : false,
    yearRange         : "c-100:c+10",
    minDate           : 0
});
$(document).ready(function () {
    /*
    | ----------------------------------------------------------------------------------------
    | datepicker 함수입니다.
    | ----------------------------------------------------------------------------------------
    */
    // 시작날짜 - 제한 없음 (과거 날짜도 선택 가능)
    $("#sstartdate").datepicker({
        minDate : null, // 명시적으로 제한 없음 설정
        onSelect: function (selectedDate) {
            // 시작날짜가 선택되면 종료날짜의 최소값을 설정
            $("#senddate").datepicker("option", "minDate", selectedDate);
        }
    });
    // 종료날짜 - 오늘 이후만 선택 가능하고, 시작날짜 이후만 선택 가능
    $("#senddate").datepicker({
        minDate : null,
        onSelect: function (selectedDate) {
            // 종료날짜가 선택되면 시작날짜의 최대값을 설정
            $("#sstartdate").datepicker("option", "maxDate", selectedDate);
        }
    });

    // 나머지 datepicker는 오늘 이후만 선택 가능하도록 설정
    $(".datepicker").not("#sstartdate, #senddate").datepicker({
        minDate: 0 // 일반 datepicker는 오늘 이후만 선택 가능
    });
});

window.Quill = Quill;
const Font = Quill.import('formats/font');
// 퀼 에디터에서 사용할 폰트 설정 (폰트 화이트리스트 설정)
Font.whitelist = ['pretendard', 'roboto', 'space-mono', 'montserrat', 'noto', 'nanum', 'dotum', 'arial', 'sans-serif'];
const Size = Quill.import('attributors/style/size');
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px'];
Quill.register(Size, true);
// 퀼에 폰트 포맷을 등록
Quill.register(Font, true);
const quillOption = {
    modules: {
        toolbar: {
            container: [
                [{header: [1, 2, 3, false]}],
                [{font: ['pretendard', 'roboto', 'space-mono', 'montserrat', 'noto', 'nanum', 'dotum', 'arial', 'sans-serif']}],
                [{size: ['14px', '10px', '12px', '16px', '18px', '20px', '24px']}], // 글자 크기 추가
                ['bold', 'italic', 'underline', 'strike'],
                [{list: 'ordered'}, {list: 'bullet'}],
                [{align: []}],
                ['link', 'image', 'video', 'code-block']
            ],
            handlers : {
                image: QuillimageHandler // 이미지 버튼 클릭 시 호출될 핸들러
            }
        },

    },
    theme  : 'snow'
};

function setQuillEditor(holderSelector, textareaSelector) {
    const holder = document.querySelector(holderSelector); // ← 여기서 DOM 요소로 변환
    if (!holder) {
        console.error(`에디터 DOM 요소를 찾을 수 없습니다: ${holderSelector}`);
        return;
    }

    const instance = new Quill(holder, quillOption);
    window.quill = instance;
    instance.root.style.fontSize = '14px';

    // 드래그 앤 드롭 및 붙여넣기 이벤트는 여기에서 연결해야 함!
    instance.root.addEventListener('drop', (e) => {
        e.preventDefault();
        if (e.dataTransfer.files.length) {
            QuillhandleImageUpload(e.dataTransfer.files[0]);
        }
    });

    instance.root.addEventListener('paste', (e) => {
        const items = e.clipboardData.items;
        for (let item of items) {
            if (item.type.indexOf('image') !== -1) {
                e.preventDefault();
                QuillhandleImageUpload(item.getAsFile());
                break;
            }
        }
    });

    const textarea = document.querySelector(textareaSelector);
    if (textarea) {
        // ✅ 초기값 세팅
        const initialContent = textarea.value;
        if (initialContent) {
            instance.clipboard.dangerouslyPasteHTML(initialContent);
        }

        // ✅ 에디터 내용 → textarea로 동기화
        instance.on('text-change', function () {
            textarea.value = instance.root.innerHTML;
        });
    }


    return instance;
}

// 드래그 앤 드롭 및 붙여넣기 처리
/*
window.quill.root.addEventListener('drop', (e) => {
    e.preventDefault();
    if (e.dataTransfer.files.length) {
        QuillhandleImageUpload(e.dataTransfer.files[0]);
    }
});

window.quill.root.addEventListener('paste', (e) => {
    const items = e.clipboardData.items;
    for (let item of items) {
        if (item.type.indexOf('image') !== -1) {
            e.preventDefault();
            QuillhandleImageUpload(item.getAsFile());
            break;
        }
    }
});
*/
async function QuillhandleImageUpload(file) {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('_token', '{{ csrf_token() }}');

    try {
        const response = await fetch('/editor/upload-quill', {
            method : 'POST',
            body   : formData,
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        });

        const data = await response.json();
        if (data.imageUrl) {
            const range = window.quill.getSelection(true);
            window.quill.insertEmbed(range.index, 'image', data.imageUrl);
            window.quill.setSelection(range.index + 1);
        } else {
            alert('이미지 업로드 실패');
        }
    } catch (error) {
        console.error('업로드 중 오류:', error);
    }
}

function QuillimageHandler() {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
        const file = input.files[0];
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch('/editor/upload-quill', {
                method : 'POST',
                body   : formData,
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            });

            const data = await response.json();
            if (data.imageUrl) {
                const range = window.quill.getSelection(true);
                window.quill.insertEmbed(range.index, 'image', data.imageUrl);
                window.quill.setSelection(range.index + 1);
            } else {
                alert('이미지 업로드 실패');
            }
        } catch (error) {
            console.error('업로드 중 오류:', error);
        }
    };
}

window.oEditors = [];

function setEditor(holder) {
    nhn.husky.EZCreator.createInIFrame({
        oAppRef      : window.oEditors,
        elPlaceHolder: holder,
        sSkinURI     : "/plugin/smarteditor/SmartEditor2Skin.html",
        htParams     : {
            bUseToolbar        : true,				// 툴바 사용 여부 (true:사용/ false:사용하지 않음)
            bUseVerticalResizer: true,		// 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)
            bUseModeChanger    : true,			// 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)
            fOnBeforeUnload    : function () {
                //alert("아싸!");
            }
        }, //boolean
        fOnAppLoad   : function () {
            //예제 코드
            //oEditors.getById["contents"].exec("PASTE_HTML", ["로딩이 완료된 후에 본문에 삽입되는 text입니다."]);
        },
        fCreator     : "createSEditor2"
    });

    return window.oEditors;
}


const ToastEditor = require('@toast-ui/editor');


import colorSyntax from '@toast-ui/editor-plugin-color-syntax';


import codeSyntaxHighlight from '@toast-ui/editor-plugin-code-syntax-highlight';


import tableMergedCell from '@toast-ui/editor-plugin-table-merged-cell';

function setToastEditor(holderSelector, textareaSelector) {
    const holder = document.querySelector(holderSelector);
    if (!holder) {
        console.error(`에디터 DOM 요소를 찾을 수 없습니다: ${holderSelector}`);
        return;
    }

    const textarea = document.querySelector(textareaSelector);

    const editor = new ToastEditor({
        el             : holder,
        height         : '500px',
        initialEditType: 'wysiwyg',
        previewStyle   : 'vertical',
        initialValue   : textarea.value,
        plugins        : [colorSyntax, codeSyntaxHighlight, tableMergedCell],
        hooks          : {
            // ✅ 단일 이미지 업로드 fetch로 처리
            addImageBlobHook: async (blob, callback) => {
                const url = await uploadImageToast(blob);
                if (url) callback(url, blob.name);
            }
        }
    });

    editor.on('change', () => {
        textarea.value = editor.getHTML();
    });

    // ✅ 드래그앤드랍 다중 업로드 직접 처리
    // ✅ 에디터 내부 DOM이 완성된 뒤 이벤트 바인딩

    /* const wysiwygTarget = holder.querySelector('.toastui-editor-contents');

     if (wysiwygTarget) {
         ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
             wysiwygTarget.addEventListener(eventName, (e) => {
                 e.preventDefault();
                 e.stopPropagation();
             });
         });

         wysiwygTarget.addEventListener('drop', async (e) => {
             const files = Array.from(e.dataTransfer.files);
             const imageFiles = files.filter(file => file.type.startsWith('image/'));

             console.log('✅ drop event 발생', imageFiles);

             for (const file of imageFiles) {
                 const url = await uploadImageToast(file);
                 if (url) editor.insertText(`![](${url})\n`);
             }
         });

         console.log('✅ 드래그앤드랍 이벤트 바인딩 완료 (wysiwyg contenteditable)');
     } else {
         console.warn('❌ wysiwyg contenteditable 요소를 찾을 수 없습니다');
     }*/


    return editor;
}

// ✅ 이미지 업로드 처리 함수 (공통)
async function uploadImageToast(file) {
    try {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
        const res = await fetch('/editor/upload-toast', {
            method: 'POST',
            body  : formData
        });

        const result = await res.json();
        return result.url;
    } catch (err) {
        console.error('업로드 실패', err);
        return null;
    }
}

window.setEditor = setEditor;
window.setQuillEditor = setQuillEditor;
window.setToastEditor = setToastEditor;

import './component';
import './common';
